export default __webpack_public_path__ + "static/cigna-colorful-2d2bfd1f802ffd1bb69b9d3561cc8f82.svg";